var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1493 30.3269C12.8994 30.3271 12.6523 30.2742 12.4244 30.1716C12.1965 30.0689 11.9931 29.919 11.8276 29.7317L6.40361 23.5841L6.37929 23.5549C5.23555 22.203 4.63062 20.4164 4.63062 18.3896C4.65459 16.1459 5.5627 14.0023 7.15776 12.4242C8.75281 10.8461 10.906 9.96094 13.1498 9.96094C15.3936 9.96094 17.5468 10.8461 19.1419 12.4242C20.7369 14.0023 21.6451 16.1459 21.669 18.3896C21.669 20.3347 20.9338 22.4666 19.8785 23.6035L14.4691 29.7307C14.3039 29.9179 14.1008 30.0679 13.8733 30.1706C13.6458 30.2734 13.399 30.3267 13.1493 30.3269V30.3269ZM9.0558 21.2723L13.1493 25.9095L17.2575 21.2567C17.2711 21.2412 17.2837 21.2266 17.2973 21.213C17.6533 20.8356 18.1503 19.5791 18.1503 18.3925C18.132 17.0784 17.5971 15.8243 16.6613 14.9015C15.7255 13.9787 14.4641 13.4613 13.1498 13.4613C11.8356 13.4613 10.5741 13.9787 9.63836 14.9015C8.70259 15.8243 8.16769 17.0784 8.14937 18.3925C8.14937 19.2075 8.30692 20.3746 9.0558 21.2723Z",
    fill: "url(#paint0_linear_701_2110)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5429 19.4478C16.8346 19.6238 16.7919 20.2045 16.3571 20.5964C15.5481 21.3207 14.5004 21.7211 13.4146 21.7211C12.3288 21.7211 11.2811 21.3207 10.4721 20.5964C10.0374 20.2074 9.99749 19.6238 10.2873 19.4478C10.5791 19.2698 11.0022 19.4167 11.2978 19.6773C11.8796 20.1988 12.6334 20.4871 13.4146 20.4871C14.1959 20.4871 14.9496 20.1988 15.5314 19.6773C15.8271 19.4167 16.253 19.2698 16.5429 19.4478Z",
    fill: "#ED6E18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3922 11.642L16.7664 10.3223L16.2865 11.6407L18.9726 12.6184C19.4916 12.8073 20.0654 12.5397 20.2543 12.0207L20.3922 11.642Z",
    fill: "#FFA73B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1405 9.00258L16.7664 10.3223L16.2865 11.6407L13.6003 10.6631C13.0814 10.4742 12.8138 9.90034 13.0027 9.38136L13.1405 9.00258Z",
    fill: "#FFC02E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3926 11.6423L16.7668 10.3226L18.2064 6.36719L18.8657 6.60713C18.5092 8.86642 20.3483 9.19986 21.1427 8.55576C21.8338 7.99541 22.6115 7.5972 22.1316 8.91568C21.6517 10.2342 20.7039 11.3201 20.3926 11.6423Z",
    fill: "#FFC02E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1409 9.00293L16.7668 10.3226L18.2064 6.36719L17.5472 6.12724C16.368 8.08709 14.7448 7.16034 14.5503 6.15633C14.3811 5.28285 14.0413 4.47793 13.5614 5.79641C13.0816 7.11489 13.1095 8.55599 13.1409 9.00293Z",
    fill: "#FFF780"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0418,
    cy: 8.13637,
    r: 1.05232,
    transform: "rotate(20 22.0418 8.13637)",
    fill: "#FFA73B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1308,
    cy: 5.25698,
    r: 1.05232,
    transform: "rotate(20 14.1308 5.25698)",
    fill: "#FFC02E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3265 6.03774C18.1277 6.58387 17.9665 7.0266 17.9665 7.0266C17.4204 6.82782 17.1388 6.22396 17.3376 5.67782C17.5364 5.13169 18.1402 4.8501 18.6864 5.04888C18.6864 5.04888 18.5252 5.49161 18.3265 6.03774Z",
    fill: "#FFC02E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3151 6.39762C19.1164 6.94375 18.5125 7.22534 17.9664 7.02656C17.9664 7.02656 18.1275 6.58382 18.3262 6.03769C18.525 5.49156 18.6862 5.04884 18.6862 5.04884C19.2323 5.24762 19.5139 5.85149 19.3151 6.39762Z",
    fill: "#FFA73B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_2110",
    x1: 21.669,
    y1: 9.96094,
    x2: 1.5856,
    y2: 26.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E96039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#EB6E29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2942F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumLogo);
export default __webpack_public_path__ + "static/media/premium-logo.0b1e89f4d8fdce2dc65e36a1d35f8f7c.svg";
export { ForwardRef as ReactComponent };